export const AB_API_HOSTS = {
	development: 'https://dev-api.aofl.com',
	local_development: 'https://dev-api.aofl.com',
	production: 'https://api.aofl.com',
	// Review apps talk to the dev backend, same as development (shared-constants.js's
	// getApiBaseUrl documents the same pattern). Missing this key sent `undefined` into
	// `${host}/ws/analytics/...`, producing a relative URL the browser resolved against
	// the current page path (observed on review as /abc/login/undefined/ws/analytics/...).
	review: 'https://dev-api.aofl.com',
	staging: 'https://api.aofl.com',
};

export const DEVICE_KEY_MAP = {
	acquisition_source: 'acquisitionSource',
	device_id: 'deviceId',
	localeCode: 'localeCode',
	is_first_time_visit: 'isFirstTimeVisit',
	app_version: 'appVersion',
	country_code: 'viewerCountry',
	is_mobile_viewer: 'isMobileViewer',
	is_desktop_viewer: 'isDesktopViewer',
	is_webview: 'inApp',
	app_store: 'appStore',
	browser_platform: 'browserPlatform',
	// is_ios_viewer: 'isIosViewer',
	is_link_from_app: 'isLinkFromApp',
	is_link_from_app_platform: 'isLinkFromAppPlatform',
	is_link_from_email: 'isLinkFromEmail',
	is_automated_testing: 'isAutomatedTesting',
};

export const ACTIVE_EXPERIMENTS = {
	ABCM2_THIRD_PARTY_AUTH_WEB: {
		experimentKey: 'abcm2-third-party-auth-web',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_THIRD_PARTY_AUTH_APP: {
		experimentKey: 'abcm2-third-party-auth-app',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_MAX_TIER_OFFER: {
		experimentKey: 'subscription-tier-max',
		variants: {
			test: 'test-a',
			test_b: 'test-b',
			control: 'default',
		},
	},
	PAYPAL_APP_SWITCH: {
		experimentKey: 'paypal-app-switch',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_LOGIN_PAGE_CONDITION: {
		experimentKey: 'refactor-experiment-client-aa',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_TUTOR_OFFER: {
		experimentKey: 'onboarding-tutor-upsell',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	// EXPERIMENT_CLEANUP: teachers-nmhp-header-link
	ABCM2_TEACHERS_NMHP_HEADER_LINK: {
		experimentKey: 'teachers-nmhp-header-link',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_AA_OFFER_REDESIGN: {
		experimentKey: 'browser-academy-upsell-redesign',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_PRE_PAID_CARDS_V4: {
		experimentKey: 'decline-prepaid-cards-v4',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_ANNUAL_ASSESSMENTS_ORIGINALLY_99_99_COPY: {
		experimentKey: 'annual-assessments-originally-99-99-copy',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_ROKT: {
		experimentKey: 'browser-so-rokt-create-account-product-info',
		variants: {
			test_a: 'test a',
			test_b: 'test b',
			control: 'default',
		},
		offerHashByVariant: {
			'test a': '2kt9wrn',
			'test b': '2kt9vvn',
			'default': '123br4nd',
		},
	},
	ABCM2_SIGNIFYD_PRE_AUTH: {
		experimentKey: 'signifyd-v1',
		variants: {
			test: 'test', // Cohort B — payment routed through Signifyd pre-auth
			control: 'default', // Cohort A — BAU, direct to processor
		},
	},
	// EXPERIMENT_CLEANUP: remove ABCM2_SUB_PAGE_PAYMENT_DISPLAY from ACTIVE_EXPERIMENTS when sub-page-payment-display_ concludes.
	ABCM2_SUB_PAGE_PAYMENT_DISPLAY: {
		experimentKey: 'sub-page-payment-display_',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
	ABCM2_REMOVE_SEMIANNUAL_POPUPS: {
		experimentKey: 'abcm2-remove-semiannual-popups',
		variants: {
			test: 'test',
			control: 'default',
		},
	},
};

export const PROFILE = 'abcmouse';

export const EXPERIMENT_KEYS = [ACTIVE_EXPERIMENTS.ABCM2_MAX_TIER_OFFER.experimentKey];

export const DATA_TYPES = {
	DEVICE: 'device',
	USER: 'user',
	SESSION: 'session',
	MASTER: 'master',
};

export const DATA_KEYS = {
	REACTIVATED_USER: 'is_reactivated_user',
	SPECIAL_OFFER_USER: 'is_special_offer_user',
	SUBSCRIPTION_STATUS: 'subscription_status',
	USER_SUBSCRIPTION_TYPE: 'user_subscription_type',
};
